import React from 'react';
import { TextDecrypt } from "./TextDecrypt";
import { home } from "../data";
import UseAnimation from "react-useanimations";
import download from 'react-useanimations/lib/download';
// import hero image
import HeroImg from '../assets/img/33.webp';

// import components
import { useDencrypt } from "use-dencrypt-effect";

const values = ["Frontend Developer", "Backend Developer", "UI / UX DESIGNER"];


const Hero = () => {
  const { result, dencrypt } = useDencrypt();
  React.useEffect(() => {
    let i = 0;
    const action = setInterval(() => {
      dencrypt(values[i]);
      i = i === values.length - 1 ? 0 : i + 1;
    }, 3000);
    return () => clearInterval(action);
  }, [dencrypt]);

  return (
    <section
      id='home'
      className='h-full flex items-center   py-32 lg:py-0 overflow-hidden'
    >
      {home.map((val, i) => (
      <div className='container mx-auto '>
        <div className='flex items-center h-full pt-8'>
          <div className='flex-1 flex flex-col items-center lg:items-start'>
            <span className='text-lg text-accent text-md mb-[22px]'>
              Hey, I'm!
            </span>
            <h4 className='text-2xl lg:text-3xl font-medium lg:font-extrabold mb-3 '>
            <TextDecrypt  text={`${val.name}`}/>
            </h4>
            <h1 className='text-3xl lg:text-6xl font-medium lg:font-extrabold mb-3'>
            <TextDecrypt
            text={`${val.post}`}
            />
            </h1>
            <h1 className=' text-accent text-3xl lg:text-5xl font-medium lg:font-extrabold mb-8 '>
            {result}
            </h1>
            <button className='btn btn-md rounded-md text-black bg-accent hover:bg-accent-hover1 transition-all'>
              <a  href="https://docs.google.com/document/d/1NpRJ3zIAR2lO5VI9UXr1B9IeaaY6U1NCfyh13ISeaPQ" download>
                <UseAnimation animation={download} autoplay="true*" fillColor='#1d4ed8' size={39} />
              </a>
              Download CV
            </button>
          </div>
          <div className='hidden lg:flex flex-1 justify-end items-end '>
            <img src={HeroImg} alt='' />
          </div>
        </div>
      </div>
      ))}
    </section>
  );
};

export default Hero;
